export enum Team {
  TURKU = 'turku',
  HELSINKI = 'helsinki',
  GOTHENBURG = 'gothenburg',
  MALAGA_FINLAND = 'malaga-finland',
  MALAGA_SWEDEN = 'malaga-sweden',
  UK = 'uk',
}
